import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import ProductDetailController from '../controllers/ProductDetailController';

export default class ProductListDirectiveController {
    static $inject = [ '$scope', '$mdDialog', 'CatalogService', 'CartService', '$timeout', 'Message', '$location' ];

    constructor(scope, mdDialog, catalogService, cartService, timeoutService, messageService, locationService) {

        this._scope = scope;
        this._catalogService = catalogService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._timeoutService = timeoutService;
        this._dialogService = mdDialog;
        this._locationService = locationService;

        scope.products = [];
        scope.pageNum = 0;
        scope.hasMore = true;

        scope.loadMore = () => this._loadMore();
        scope.customizeProduct = (product) => this._customizeProduct(product);
        scope.endCustomizeProduct = (product) => this._endCustomizeProduct(product);
        scope.customizeKeyPressed = ($event, product) => this._customizeKeyPressed($event, product);

        scope.$watch('categoryId', (newValue, oldValue) => this._onCategoryIdChanged(newValue, oldValue));

        scope.$watch('searchString', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.refreshList();
            }
        });

        scope.showProductDetail = (product) => this._showProductDetail(product);
        scope.addToCart = (product) => this._addToCart(product);
    }

    async $onInit() {
        this.refreshList();
    }

    _loadMore() {
        this._scope.pageNum++;
        this.refreshList();
    }

    _customizeProduct(product) {
        product.showComment = true;
        product.setFocus();
    }

    _endCustomizeProduct(product) {
        if (!product.comment.length) {
            product.showComment = false;
        }
        this._addToCart(product);
    }

    _customizeKeyPressed($event, product) {
        if ($event.which === 13) {
            this.endCustomizeProduct(product);
        }
    }

    _onCategoryIdChanged(newValue, oldValue) {

        if (newValue === oldValue) {
            return;
        }

        this.catDefaults();
        this.refreshList();
    }

    catDefaults() {
        this._scope.pageNum = 0;
        this._scope.hasMore = true;
        this._scope.products = [];
    }

    prepareProducts() {

        _.each(this._scope.products, (product) => {
            if (!product.image) {
                product.image = Constants.DEFAULT_PRODUCT_IMAGE;
            } else {
                product.image = product.image.replace(/^(\w)+\:/, () => {
                    return this._locationService.protocol() + ':';
                });
            }
            product.quantity = 1;
            product.comment = "";
            product.showComment = false;
            product.addedState = false;
            product.setFocus = function () {
            };
        });
    }

    refreshList() {

        if (!this._scope.searchString && !this._scope.categoryId) {
            this._scope.products = [];
            return;
        }

        if (_.isEmpty(this._scope.searchString)) {
            let limit = Constants.Pagination.PAGE_LIMIT;
            let offset = this._scope.pageNum * limit;
            this._catalogService.getProductsBySuperCategory(this._scope.categoryId, offset, limit).then((data) => {
                let _products = data || [];
                if (_.isEmpty(_products)) {
                    this._scope.hasMore = false;
                }

                this._scope.products = this._scope.products.concat(_products);
                this.prepareProducts();
            });
        } else {
            this._catalogService.searchProducts(this._scope.searchString, 0).then((data) => {
                this._scope.products = data.productList.result || {};
                this.prepareProducts();
            });
        }
    }

    _showProductDetail(product) {
        this._catalogService.getProduct(product.id).then((product) => {
            this._dialogService.show({
                controller: ProductDetailController,
                templateUrl: '/modules/catalog/views/productDetails.html',
                clickOutsideToClose: true,
                locals: {
                    product: product
                }
            });
        });
    }

    _addToCart(product) {

        this._cartService.addProduct({
            id: product.id,
            image: product.image,
            quantity: product.quantity || 1,
            comment: product.comment,
            name: product.name,
            price: product.price
        }).then(() => {
            product.quantity = 1;
            product.comment = "";
            product.showComment = false;
            product.addedState = true;
            this._timeoutService(() => {
                product.addedState = false;
            }, 3000);
        }, error => this._messageService.showErrorPopupForResponse(error));
    }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/directives/ProductListDirective.js